import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './i18n';
import './App.css';
import useWebsiteSettings from './hooks/useWebsiteSettings';
import useFavicon from './hooks/useFavicon';

// Components
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import LoadingSpinner from './components/LoadingSpinner';
import ScrollToTop from './components/ScrollToTop';
import PageTransition from './components/PageTransition';

// Admin Routes
import AdminRoutes from './AdminRoutes';

// Lazy load pages for better performance
const Home = lazy(() => import('./pages/Home'));
const About = lazy(() => import('./pages/About'));
const Portfolio = lazy(() => import('./pages/Portfolio'));
const News = lazy(() => import('./pages/News'));
const MetalDesigns = lazy(() => import('./pages/MetalDesigns'));
const Careers = lazy(() => import('./pages/Careers'));
const Contact = lazy(() => import('./pages/Contact'));
const Partners = lazy(() => import('./pages/Partners'));



// Layout wrapper to conditionally render components based on route
const AppLayout = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/lisa');
  const { settings } = useWebsiteSettings();
  
  // Update favicon dynamically
  useFavicon(settings.faviconUrl);

  if (isAdminRoute) {
    return <AdminRoutes />;
  }

  return (
    <div className="App">
      <Navigation />
      <Suspense fallback={<LoadingSpinner />}>
        <PageTransition>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/news" element={<News />} />
            <Route path="/metal-designs" element={<MetalDesigns />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact" element={<Contact />} />
<Route path="/partners" element={<Partners />} />
          </Routes>
        </PageTransition>
      </Suspense>
      <Footer />
      <ScrollToTop />
    </div>
  );
};

function App() {
  return (
    <Router>
      <AppLayout />
    </Router>
  );}


export default App;